import ContentRating from "../../../../src/mdx/optional-settings/content-rating.mdx";
import * as React from 'react';
export default {
  ContentRating,
  React
};